import { useEffect, useState } from "react";
import { Raffle } from "../../contexts";
import useRaffles from "../../hooks/useRaffles";
import { useWallet } from "@solana/wallet-adapter-react";
import { Tab, Tabs, Form, Button, Row, Col } from "react-bootstrap";
import { IoIosClose } from "react-icons/io";
import useApi from "../../hooks/useApi";
import { toast } from "react-toastify";

const MONTHS = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export default function MyRaffles({ show, toggleShow }) {
  const { myRaffles: raffles } = useRaffles();
  const wallet = useWallet();
  const [myRaffles, setMyRaffles] = useState<Raffle[]>([]);
  const [myWons, setMyWons] = useState<Raffle[]>([]);
  const api = useApi();

  const [data, setData] = useState<any>({
    name: "",
    email: "",
    phone: "",
    streetAddress: "",
    aptSuite: "",
    city: "",
    zip: "",
    state: "",
    country: "",
    discordId: "",
    merchSize: "",
  });

  useEffect(() => {
    (async () => {
      const myRaffles = raffles.map((raffle) => raffle.raffle);
      setMyRaffles(myRaffles);
      setMyWons(
        raffles.filter((raffle) => raffle.isWon).map((raffle) => raffle.raffle)
      );
    })();
  }, [raffles]);

  useEffect(() => {
    (async () => {
      if (!wallet.publicKey) return;
      const data = await api
        .get(`get_profile/${wallet.publicKey.toString()}`)
        .catch((e) => null);
      setData((d) => ({ ...d, discordId: data?.data?.discordId }));
    })();
  }, [wallet]);

  const handleChange = (e: any) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    if (!wallet.publicKey) return;
    api
      .post("profile", {
        ...data,
        wallet_address: wallet.publicKey?.toString(),
      })
      .then((res) => {
        toast.success("Successfully Updated Profile!");
      })
      .catch((err) => toast.error(err.message));
  };

  return (
    <div className={"my-raffles" + (show ? " show" : "")}>
      {/* Use Tabs here to show myRaffles and myWonRaffles and also put a Close or something and call toggleShow(!show) onClick */}
      <div className="d-flex">
        {" "}
        <span className="ml-auto" onClick={() => toggleShow(!show)}>
          <IoIosClose size={35} />
        </span>{" "}
      </div>
      <Tabs
        defaultActiveKey="raffles"
        id="uncontrolled-tab-example"
        className="mb-3"
      >
        <Tab eventKey="raffles" title=" My Raffles">
          {myRaffles.length
            ? myRaffles.map((raffle) => {
                return (
                  <>
                    <Row className="user-raffles ">
                      <Col md="2">
                        <h4>{raffle.name}</h4>
                      </Col>
                      <Col md="2">
                        <h6>Total Tickets</h6>
                        <p>{raffle.tickets}</p>
                      </Col>
                      <Col md="2">
                        <h6>My Tickets</h6>
                        <p>
                          {
                            raffle.participants.find(
                              (p) =>
                                p.owner.toString() ==
                                wallet.publicKey?.toString()
                            )?.tickets
                          }
                        </p>
                      </Col>
                      <Col md="2">
                        <h6>$GOD Spent</h6>
                        <p>
                          {
                          (
                            //@ts-ignore
                            raffle.participants.find(
                              (p) =>
                                p.owner.toString() ==
                                wallet.publicKey?.toString()
                            )?.tickets * raffle.price
                          ).toFixed(1)}
                        </p>
                      </Col>
                      <Col md="2">
                        <h6>Status</h6>
                        <p>{raffle.isClosed ? "Closed" : "Open"}</p>
                      </Col>
                      <Col md="2">
                        <h6>End Date</h6>
                        <p>
                          {raffle.end.getDate()} /{" "}
                          {MONTHS[raffle.end.getMonth()]} /{" "}
                          {raffle.end.getFullYear()}
                        </p>
                      </Col>
                    </Row>
                    <hr />
                  </>
                );
              })
            : "no raffles found!"}
        </Tab>
        <Tab eventKey="profile" title="My Wins">
          {myWons.length ? (
            myWons.map((raffle) => {
              return (
                <>
                  <Row className="user-raffles ">
                    <Col md="2">
                      <h4>{raffle.name}</h4>
                    </Col>
                    <Col md="2">
                      <h6>Total entries</h6>
                      <p>{raffle.tickets}</p>
                    </Col>
                    <Col md="2">
                      <h6>your entries</h6>
                      <p>
                        {
                          raffle.participants.find(
                            (p) =>
                              p.owner.toString() == wallet.publicKey?.toString()
                          )?.tickets
                        }
                      </p>
                    </Col>
                    <Col md="2">
                      <h6>$GOD Spent</h6>
                      <p>
                        {
                          (
                            //@ts-ignore
                            raffle.participants.find(
                              (p) =>
                                p.owner.toString() ==
                                wallet.publicKey?.toString()
                            )?.tickets * raffle.price
                          ).toFixed(1)
                        }
                      </p>
                    </Col>
                    <Col md="2">
                      <h6>Status</h6>
                      <p>{raffle.isClosed ? "Closed" : "Open"}</p>
                    </Col>
                    <Col md="2">
                      <h6>end date</h6>
                      <p>
                        {raffle.end.getDate()} / {MONTHS[raffle.end.getMonth()]}{" "}
                        / {raffle.end.getFullYear()}
                      </p>
                    </Col>
                  </Row>
                  <hr />
                </>
              );
            })
          ) : (
            <p>No wins yet! Test your luck and enter our latest raffle!</p>
          )}
        </Tab>
        <Tab eventKey="contact" title="Profile">
          {/* <p>
            Your contact information is required to sent out prizes when you win
            a raffle. Please check details of raffles you have won to see if
            this information is required. <br />
            We reccomend you enter your Discord Id so we have a way of
            contacting you.
          </p> */}
          <p>
            Please enter your Discord ID. In the event of winning a raffle for a
            non-NFT prize, we need a way to contact you.
          </p>
          <Form onSubmit={handleSubmit}>
            <Row className="profile-forms">
              <Col md="12" xs="12">
                <Form.Group className="mb-3">
                  <Form.Label>
                    Discord ID <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Text className="text-muted">
                    Include the #number
                  </Form.Text>
                  <Form.Control
                    type="text"
                    name="discordId"
                    value={data.discordId}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>
              {/* <Col md="6" xs="12">
                <Form.Group className="mb-3">
                  <Form.Label>
                    Merch Size <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Text className="text-muted">
                    Example: Shirt - Small, shoes - 7 US Mens
                  </Form.Text>
                  <Form.Control
                    type="text"
                    name="merchSize"
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>
              <Col md="6" xs="12">
                <Form.Group className="mb-3">
                  <Form.Label>
                    Name <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="name"
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>
              <Col md="6" xs="12">
                <Form.Group className="mb-3">
                  <Form.Label>
                    Phone <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="phone"
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>

              <Col md="12" xs="12">
                <Form.Group className="mb-3">
                  <Form.Label>
                    Email <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    type="email"
                    name="email"
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>
              <Col md="12" xs="12">
                <Form.Group className="mb-3">
                  <Form.Label>
                    Street Address<span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="streetAddress"
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>
              <Col md="12" xs="12">
                <Form.Group className="mb-3">
                  <Form.Label>Apt, Suite, etc.</Form.Label>
                  <Form.Control
                    type="text"
                    name="aptSuite"
                    onChange={handleChange}
                  />
                </Form.Group>
              </Col>
              <Col md="6" xs="12">
                <Form.Group className="mb-3">
                  <Form.Label>
                    City<span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="city"
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>
              <Col md="6" xs="12">
                <Form.Group className="mb-3">
                  <Form.Label>
                    Zip/ Postal Code<span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="zip"
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>
              <Col md="6" xs="12">
                <Form.Group className="mb-3">
                  <Form.Label>
                    State <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="state"
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>
              <Col md="6" xs="12">
                <Form.Group className="mb-3">
                  <Form.Label>
                    Country<span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="country"
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col> */}
              <Button variant="danger-outline" type="submit">
                Submit
              </Button>
            </Row>
          </Form>
        </Tab>
      </Tabs>
    </div>
  );
}
